// (C) Copyright 2020 MediaWink, LLC

import React from 'react';

export const Context = React.createContext();
